import Vue from 'vue'
import init from './helpers/init'
import Checkout from './views/Checkout'
import Personal from './views/Personal'

Vue.config.productionTip = false

init('#view-checkout', Checkout, 'vue');
init('#view-personal', Personal, 'vue');

